const question_data = {
  android: {
    car_model: [
      {
          "Car Make-Model": "Abarth  595 2017-2023"
      },
      {
          "Car Make-Model": "Abarth  695 2017-2023"
      },
      {
          "Car Make-Model": "Acura  MDX 2018-2023"
      },
      {
          "Car Make-Model": "Acura  NSX 2017-2023"
      },
      {
          "Car Make-Model": "Acura  TLX 2018-2023"
      },
      {
          "Car Make-Model": "Alfa Romeo  Giulia 2017-2023"
      },
      {
          "Car Make-Model": "Alfa Romeo  Giulietta 2017-2023"
      },
      {
          "Car Make-Model": "Alfa Romeo  Stelvio 2017-2023"
      },
      {
          "Car Make-Model": "Alfa Romeo  MiTo 2017-2023"
      },
      {
          "Car Make-Model": "Aston Martin  Rapide 2018-2023"
      },
      {
          "Car Make-Model": "Aston Martin  Vanquish 2018-2023"
      },
      {
          "Car Make-Model": "Aston Martin  Vantage 2018-2023"
      },
      {
          "Car Make-Model": "Audi  A1 2019-2023"
      },
      {
          "Car Make-Model": "Audi  A3 2017-2023"
      },
      {
          "Car Make-Model": "Audi  A4 2017-2023"
      },
      {
          "Car Make-Model": "Audi  A5  2017-2023"
      },
      {
          "Car Make-Model": "Audi  A6  2017-2023"
      },
      {
          "Car Make-Model": "Audi  A7 2017-2023"
      },
      {
          "Car Make-Model": "Audi  A8 2018-2023"
      },
      {
          "Car Make-Model": "Audi  Q2 2017-2023"
      },
      {
          "Car Make-Model": "Audi  Q3 2019-2023"
      },
      {
          "Car Make-Model": "Audi  Q5 2018-2023"
      },
      {
          "Car Make-Model": "Audi  Q7 2016-2023"
      },
      {
          "Car Make-Model": "Audi  Q8 2019-2023"
      },
      {
          "Car Make-Model": "Audi  R8 2017-2023"
      },
      {
          "Car Make-Model": "Audi  TT 2017-2023"
      },
      {
          "Car Make-Model": "BMW  1 Series  2020-2023"
      },
      {
          "Car Make-Model": "BMW  2 Series 2020-2023"
      },
      {
          "Car Make-Model": "BMW  3 Series 2019-2023"
      },
      {
          "Car Make-Model": "BMW  4 Series 2021-2023"
      },
      {
          "Car Make-Model": "BMW  5 Series 2020-2023"
      },
      {
          "Car Make-Model": "BMW  6 Series 2020-2023"
      },
      {
          "Car Make-Model": "BMW  7 Series 2020-2023"
      },
      {
          "Car Make-Model": "BMW  8 Series 2019-2023"
      },
      {
          "Car Make-Model": "BMW  X3   2020-2023"
      },
      {
          "Car Make-Model": "BMW  X4 2020-2023"
      },
      {
          "Car Make-Model": "BMW  X5  2019-2023"
      },
      {
          "Car Make-Model": "BMW  X6   2020-2023"
      },
      {
          "Car Make-Model": "BMW  X7  2019-2023"
      },
      {
          "Car Make-Model": "BMW  Z4  2019-2023"
      },
      {
          "Car Make-Model": "Borgward  BX5 2019-2023"
      },
      {
          "Car Make-Model": "Borgward  BX7 2018-2023"
      },
      {
          "Car Make-Model": "Buick  Encore  2017-2023"
      },
      {
          "Car Make-Model": "Buick  Envision  2017-2023"
      },
      {
          "Car Make-Model": "Buick  LaCrosse  2016-2023"
      },
      {
          "Car Make-Model": "Buick  Regal  2016-2023"
      },
      {
          "Car Make-Model": "BYD  TANG  2021-2023"
      },
      {
          "Car Make-Model": "BYD  ATTO 3 2022-2023"
      },
      {
          "Car Make-Model": "Cadillac  ATS  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  ATS Coupe  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  ATS Sedan  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  ATS V-Coupe  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  ATS V-Sedan  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  ATS-V  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  CT6  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  CT6 Plug-in  2017-2023"
      },
      {
          "Car Make-Model": "Cadillac  CT6 Sedan  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  CTS  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  CTS Sedan  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  CTS V-Sedan  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  CTS-V  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  ELR  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  Escalade  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  Escalade ESV  2016-2023"
      },
      {
          "Car Make-Model": "Cadillac  XT5  2017-2023"
      },
      {
          "Car Make-Model": "Cadillac  XTS  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Aveo 2017-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Bolt EV  2017-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Camaro 2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Camaro Convertible  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Colorado  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Colorado/S10  2017-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Corvette 2016- 2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Corvette Convertible  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Cruze  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Cruze Hatchback  2017-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Equinox  2018-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Impala  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Malibu  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Onix - 2017-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Prisma 2017-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Silverado  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Silverado HD  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Sonic  2017-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Spark  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Suburban 2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Tahoe  2016-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Trailblazer  2017-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Traverse  2018-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Trax  2017-2023"
      },
      {
          "Car Make-Model": "Chevrolet  Volt  2016-2023"
      },
      {
          "Car Make-Model": "Chrysler  300 2017-2023"
      },
      {
          "Car Make-Model": "Chrysler  Pacifica 2018-2023"
      },
      {
          "Car Make-Model": "Citroen  Berlingo  2018-2023"
      },
      {
          "Car Make-Model": "Citroen  C-Elysée  2017-2023"
      },
      {
          "Car Make-Model": "Citroen  C3  2017-2023"
      },
      {
          "Car Make-Model": "Citroen  C3 Aircross  2017-2023"
      },
      {
          "Car Make-Model": "Citroen  C4  2017-2023"
      },
      {
          "Car Make-Model": "Citroen  C4 Cactus  2018-2023"
      },
      {
          "Car Make-Model": "Citroen  C4 Picasso  2017-2023"
      },
      {
          "Car Make-Model": "Citroen  Grand C4 Picasso  2017-2023"
      },
      {
          "Car Make-Model": "Citroen  C4 SpaceTourer  2018-2023"
      },
      {
          "Car Make-Model": "Citroen  Grand C4 SpaceTourer  2018-2023"
      },
      {
          "Car Make-Model": "Citroen  C5 Aircross  2019-2023"
      },
      {
          "Car Make-Model": "Citroen  Jumpy  2017-2023"
      },
      {
          "Car Make-Model": "Citroen  SpaceTourer 2017-2023"
      },
      {
          "Car Make-Model": "Dodge  Challenger 2017-2023"
      },
      {
          "Car Make-Model": "Dodge  Charger 2017-2023"
      },
      {
          "Car Make-Model": "Dodge  Durango 2018-2023"
      },
      {
          "Car Make-Model": "DS  DS3  2018-2023"
      },
      {
          "Car Make-Model": "DS  DS3 CROSSBACK  2019-2023"
      },
      {
          "Car Make-Model": "DS  DS4  2017-2023"
      },
      {
          "Car Make-Model": "DS  DS4 CROSSBACK 2017-2023"
      },
      {
          "Car Make-Model": "DS  DS5  2017-2023"
      },
      {
          "Car Make-Model": "DS  DS7 CROSSBACK  2018-2023"
      },
      {
          "Car Make-Model": "Ferrari  GTC4Lusso 2019-2023"
      },
      {
          "Car Make-Model": "Ferrari  GTC4Lusso T 2019-2023"
      },
      {
          "Car Make-Model": "Ferrari  Portofino 2019-2023"
      },
      {
          "Car Make-Model": "Fiat  500 2017-2023"
      },
      {
          "Car Make-Model": "Fiat  500L 2017-2023"
      },
      {
          "Car Make-Model": "Fiat  500X  2017-2023"
      },
      {
          "Car Make-Model": "Fiat  Argo  2017-2023"
      },
      {
          "Car Make-Model": "Fiat  Tipo  2017-2023"
      },
      {
          "Car Make-Model": "Ford  C-MAX 2017-2023"
      },
      {
          "Car Make-Model": "Ford  Ecosport  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Edge  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Escape  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Everest - 2017-2023"
      },
      {
          "Car Make-Model": "Ford  Expedition- 2017-2023"
      },
      {
          "Car Make-Model": "Ford  Explorer  2017-2023"
      },
      {
          "Car Make-Model": "Ford  F-150  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Fiesta  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Flex  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Focus  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Fusion 2017-2023"
      },
      {
          "Car Make-Model": "Ford  Galaxy  2017-2023"
      },
      {
          "Car Make-Model": "Ford  GT  2017-2023"
      },
      {
          "Car Make-Model": "Ford  KA+  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Kuga  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Mondeo  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Mustang  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Ranger  2017-2023"
      },
      {
          "Car Make-Model": "Ford  S-MAX  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Super Duty  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Taurus  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Tourneo Connect 2017-2023"
      },
      {
          "Car Make-Model": "Ford  Tourneo Courier - 2017-2023"
      },
      {
          "Car Make-Model": "Ford  Tourneo Custom 2017-2023"
      },
      {
          "Car Make-Model": "Ford  Transit 2017-2023"
      },
      {
          "Car Make-Model": "Ford  Transit Connect 2017-2023"
      },
      {
          "Car Make-Model": "Ford  Transit Courier  2017-2023"
      },
      {
          "Car Make-Model": "Ford  Transit Custom  2017-2023"
      },
      {
          "Car Make-Model": "Genesis  G70  2017-2023"
      },
      {
          "Car Make-Model": "Genesis  G80 2016-2023"
      },
      {
          "Car Make-Model": "Genesis  G90  2018-2023"
      },
      {
          "Car Make-Model": "GMC  Acadia  2017-2023"
      },
      {
          "Car Make-Model": "GMC  Canyon 2016-2023"
      },
      {
          "Car Make-Model": "GMC  Sierra 2016-2023"
      },
      {
          "Car Make-Model": "GMC  Yukon  2016-2023"
      },
      {
          "Car Make-Model": "GMC  Yukon Denali  2016-2023"
      },
      {
          "Car Make-Model": "GMC  Yukon XL  2016-2023"
      },
      {
          "Car Make-Model": "Holden  Acadia 2018-2023"
      },
      {
          "Car Make-Model": "Holden  Astra  2017-2023"
      },
      {
          "Car Make-Model": "Holden  Barina 2017-2023"
      },
      {
          "Car Make-Model": "Holden  Captiva  2016-2023"
      },
      {
          "Car Make-Model": "Holden  Colorado  2017-2023"
      },
      {
          "Car Make-Model": "Holden  Commodore  2018-2023"
      },
      {
          "Car Make-Model": "Holden  Equinox 2018-2023"
      },
      {
          "Car Make-Model": "Holden  Spark  2016-2023"
      },
      {
          "Car Make-Model": "Holden  Trailblazer  2017-2023"
      },
      {
          "Car Make-Model": "Holden  Trax 2017-2023"
      },
      {
          "Car Make-Model": "Honda  Accord  2016-2023"
      },
      {
          "Car Make-Model": "Honda  Civic 2016-2023"
      },
      {
          "Car Make-Model": "Honda  Clarity Fuel Cell  2017-2023"
      },
      {
          "Car Make-Model": "Honda  CR-V  2017-2023"
      },
      {
          "Car Make-Model": "Honda  Fit  2018-2023"
      },
      {
          "Car Make-Model": "Honda  Freed 2017-2023"
      },
      {
          "Car Make-Model": "Honda  Odyssey  2018-2023"
      },
      {
          "Car Make-Model": "Honda  Pilot 2017-2023"
      },
      {
          "Car Make-Model": "Honda  Ridgeline  2017-2023"
      },
      {
          "Car Make-Model": "Hyundai  Avante 2017-2023"
      },
      {
          "Car Make-Model": "Hyundai  Azera  2015-2023"
      },
      {
          "Car Make-Model": "Hyundai  Creta 2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Elantra  2017-2023"
      },
      {
          "Car Make-Model": "Hyundai  Elantra GT  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Grand i10  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Grandeur  2015-2023"
      },
      {
          "Car Make-Model": "Hyundai  i10  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  i20  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  i30 2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  i40  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Ioniq Electric 2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Ioniq Hybrid  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Ioniq Plug-in Hybrid  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Kona  2017-2023"
      },
      {
          "Car Make-Model": "Hyundai  Maxcruz 2017-2023"
      },
      {
          "Car Make-Model": "Hyundai  Palisade  2018-2023"
      },
      {
          "Car Make-Model": "Hyundai  Santa Fe  2017-2023"
      },
      {
          "Car Make-Model": "Hyundai  Santa Fe Sport 2017-2023"
      },
      {
          "Car Make-Model": "Hyundai  Sonata  2015-2023"
      },
      {
          "Car Make-Model": "Hyundai  Sonata Hybrid  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Sonata Plug-in Hybrid  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Tucson  2016-2023"
      },
      {
          "Car Make-Model": "Hyundai  Veloster  2017-2023"
      },
      {
          "Car Make-Model": "Infiniti  Q50  2020-2023"
      },
      {
          "Car Make-Model": "Infiniti  Q60 2020-2023"
      },
      {
          "Car Make-Model": "Infiniti  QX50 2020-2023"
      },
      {
          "Car Make-Model": "Infiniti  QX80 2020-2023"
      },
      {
          "Car Make-Model": "Iveco  Daily  2019-2023"
      },
      {
          "Car Make-Model": "Jaguar  XJ 2019-2023"
      },
      {
          "Car Make-Model": "Jaguar  XF  2019-2023"
      },
      {
          "Car Make-Model": "Jaguar  XE  2019-2023"
      },
      {
          "Car Make-Model": "Jaguar  F-Pace  2019-2023"
      },
      {
          "Car Make-Model": "Jaguar  F-Type  2019-2023"
      },
      {
          "Car Make-Model": "Jaguar  E-Pace 2019-2023"
      },
      {
          "Car Make-Model": "Jaguar  I-Pace  2019-2023"
      },
      {
          "Car Make-Model": "Jeep  Compass 2017-2023"
      },
      {
          "Car Make-Model": "Jeep  Grand Cherokee  2018-2023"
      },
      {
          "Car Make-Model": "Jeep  Renegade  2017-2023"
      },
      {
          "Car Make-Model": "Jeep  Wrangler 2018-2023"
      },
      {
          "Car Make-Model": "Karma  Revero  2018-2023"
      },
      {
          "Car Make-Model": "Kia  Cadenza  2017-2023"
      },
      {
          "Car Make-Model": "Kia  Carens  2017-2023"
      },
      {
          "Car Make-Model": "Kia  Carnival  2015-2023"
      },
      {
          "Car Make-Model": "Kia  cee'd  2017-2023"
      },
      {
          "Car Make-Model": "Kia  Forte  2017-2023"
      },
      {
          "Car Make-Model": "Kia  Forte Koup  2017-2023"
      },
      {
          "Car Make-Model": "Kia  Forte5  2017-2023"
      },
      {
          "Car Make-Model": "Kia  K3  2017-2023"
      },
      {
          "Car Make-Model": "Kia  K5  2015-2023"
      },
      {
          "Car Make-Model": "Kia  K7  2017-2023"
      },
      {
          "Car Make-Model": "Kia  K9  2018-2023"
      },
      {
          "Car Make-Model": "Kia  Morning 2018-2023"
      },
      {
          "Car Make-Model": "Kia  Niro 2017-2023"
      },
      {
          "Car Make-Model": "Kia  Optima  2015-2023"
      },
      {
          "Car Make-Model": "Kia  Optima Hybrid  2015-2023"
      },
      {
          "Car Make-Model": "Kia  Optima Plug-in Hybrid  2017-2023"
      },
      {
          "Car Make-Model": "Kia  Picanto  2018-2023"
      },
      {
          "Car Make-Model": "Kia  Pride  2018-2023"
      },
      {
          "Car Make-Model": "Kia  Rio 2018-2023"
      },
      {
          "Car Make-Model": "Kia  Rondo 2017-2023"
      },
      {
          "Car Make-Model": "Kia  Sedona  2015-2023"
      },
      {
          "Car Make-Model": "Kia  Sorento  2016-2023"
      },
      {
          "Car Make-Model": "Kia  Soul  2014-2023"
      },
      {
          "Car Make-Model": "Kia  Soul Booster  2019-2023"
      },
      {
          "Car Make-Model": "Kia  Soul Booster EV 2019-2023"
      },
      {
          "Car Make-Model": "Kia  Soul EV  2015-2023"
      },
      {
          "Car Make-Model": "Kia  Sportage  2017-2023"
      },
      {
          "Car Make-Model": "Kia  Stinger  2018-2023"
      },
      {
          "Car Make-Model": "Kia  Stonic  2018-2023"
      },
      {
          "Car Make-Model": "Lamborghini  Aventador 2018-2023"
      },
      {
          "Car Make-Model": "Lamborghini  Centenario  2016-2023"
      },
      {
          "Car Make-Model": "Lamborghini  Huracán  2019-2023"
      },
      {
          "Car Make-Model": "Lamborghini  Urus  2019-2023"
      },
      {
          "Car Make-Model": "Land Rover  Range Rover  2019-2023"
      },
      {
          "Car Make-Model": "Land Rover  Range Rover Sport  2019-2023"
      },
      {
          "Car Make-Model": "Land Rover  Range Rover Velar  2019-2023"
      },
      {
          "Car Make-Model": "Land Rover  Range Rover Evoque  2019-2023"
      },
      {
          "Car Make-Model": "Land Rover  Discovery  2019-2023"
      },
      {
          "Car Make-Model": "Land Rover  Discovery Sport  2019-2023"
      },
      {
          "Car Make-Model": "Lexus  ES  2020-2023"
      },
      {
          "Car Make-Model": "Lexus  NX  2020-2023"
      },
      {
          "Car Make-Model": "Lexus  RC  2020-2023"
      },
      {
          "Car Make-Model": "Lexus  RX  2020-2023"
      },
      {
          "Car Make-Model": "Lexus  UX 2020-2023"
      },
      {
          "Car Make-Model": "Lincoln  Continental  2017-2023"
      },
      {
          "Car Make-Model": "Lincoln  MKC  2017-2023"
      },
      {
          "Car Make-Model": "Lincoln  MKX 2017-2023"
      },
      {
          "Car Make-Model": "Lincoln  MKZ 2017-2023"
      },
      {
          "Car Make-Model": "Lincoln  MKZ Hybrid  2017-2023"
      },
      {
          "Car Make-Model": "Lincoln  Navigator  2017-2023"
      },
      {
          "Car Make-Model": "Mahindra  XUV300  2019-2023"
      },
      {
          "Car Make-Model": "Mahindra  XUV500  2015-2023"
      },
      {
          "Car Make-Model": "Mahindra  XUV700 2022-2023"
      },
      {
          "Car Make-Model": "Mahindra  Alturas G4  2018-2023"
      },
      {
          "Car Make-Model": "Mahindra  Marazzo  2018-2023"
      },
      {
          "Car Make-Model": "Mahindra  Scorpio  2019-2023"
      },
      {
          "Car Make-Model": "Mahindra  Scorpio N  2022-2023"
      },
      {
          "Car Make-Model": "Mahindra  Thar  2020-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  Baleno  2015-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  Ciaz  2014-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  Dzire  2017-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  Ertiga  2016-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  Ignis  2017-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  S-Cross 2015-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  S-Presso  2019-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  Swift  2018-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  XL6  2019-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  Vitara Brezza 2016-2023"
      },
      {
          "Car Make-Model": "Maruti Suzuki  Wagon R  2019-2023"
      },
      {
          "Car Make-Model": "Maserati  Ghibli  2017-2023"
      },
      {
          "Car Make-Model": "Maserati  GranCabrio  2018-2023"
      },
      {
          "Car Make-Model": "Maserati  GranTurismo 2018-2023"
      },
      {
          "Car Make-Model": "Maserati  Levante  2017-2023"
      },
      {
          "Car Make-Model": "Maserati  Quattroporte  2017-2023"
      },
      {
          "Car Make-Model": "Mazda  CX-3  2020-2023"
      },
      {
          "Car Make-Model": "Mazda  CX-30  2020-2023"
      },
      {
          "Car Make-Model": "Mazda  CX-5  2019-2023"
      },
      {
          "Car Make-Model": "Mazda  CX-50  2022-2023"
      },
      {
          "Car Make-Model": "Mazda  CX-60  2022-2023"
      },
      {
          "Car Make-Model": "Mazda  CX-8  2019-2023"
      },
      {
          "Car Make-Model": "Mazda  CX-9  2019-2023"
      },
      {
          "Car Make-Model": "Mazda  Mazda2  2020-2023"
      },
      {
          "Car Make-Model": "Mazda  Mazda3  2019-2023"
      },
      {
          "Car Make-Model": "Mazda  Mazda6 2018-2023"
      },
      {
          "Car Make-Model": "Mazda  MX-30  2021-2023"
      },
      {
          "Car Make-Model": "Mazda  MX-5  2019-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  A-Class  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  B-Class 2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  C-Class Cabriolet  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  C-Class Coupe  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  C-Class Sedan  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  C-Class Wagon  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  CLA Coupe  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  CLA Shooting Brake  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  CLS Coupe  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  CLS Shooting Brake  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  E-Class Cabriolet  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  E-Class Coupe  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  E-Class Sedan  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  E-Class Wagon  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  G-Class  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLA  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLC Coupe  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLC SUV  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLE  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLE Coupe  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLS  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  Mercedes-Maybach  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  S-Class Cabriolet  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  S-Class Coupé  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  S-Class Sedan  2018-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  SL  2017-2023"
      },
      {
          "Car Make-Model": "Mercedes-Benz  SLC  2017-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Xpander  2019-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  ASX  2017-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Delica D:2 2017-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Delica D:2 Custom  2017-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Eclipse Cross  2018-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  i-MiEV  2017-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Mirage  2017-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Mirage G4  2017-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Outlander  2017-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Outlander PHEV  2017-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Pajero  2016-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Pajero Sport  2016-2023"
      },
      {
          "Car Make-Model": "Mitsubishi  Triton  2016-2023"
      },
      {
          "Car Make-Model": "Nissan  Altima  2018-2023"
      },
      {
          "Car Make-Model": "Nissan  Kicks  2018-2023"
      },
      {
          "Car Make-Model": "Nissan  LEAF  2018-2023"
      },
      {
          "Car Make-Model": "Nissan  Maxima  2018-2023"
      },
      {
          "Car Make-Model": "Nissan  Murano  2018-2023"
      },
      {
          "Car Make-Model": "Nissan  NV200  2020-2023"
      },
      {
          "Car Make-Model": "Nissan  Rogue 2018-2023"
      },
      {
          "Car Make-Model": "Nissan  Rogue Sport  2019-2023"
      },
      {
          "Car Make-Model": "Nissan  Sentra  2019-2023"
      },
      {
          "Car Make-Model": "Nissan  TITAN  2019-2023"
      },
      {
          "Car Make-Model": "Nissan  TITAN XD  2019-2023"
      },
      {
          "Car Make-Model": "Nissan  Versa Note  2019-2023"
      },
      {
          "Car Make-Model": "Nissan  Versa Sedan  2019-2023"
      },
      {
          "Car Make-Model": "Opel  Adam  2016-2023"
      },
      {
          "Car Make-Model": "Opel  Ampera-e  2017-2023"
      },
      {
          "Car Make-Model": "Opel  Astra  2016-2023"
      },
      {
          "Car Make-Model": "Opel  Combo  2018-2023"
      },
      {
          "Car Make-Model": "Opel  Corsa  2016-2023"
      },
      {
          "Car Make-Model": "Opel  Crossland X  2017-2023"
      },
      {
          "Car Make-Model": "Opel  Grandland X  2018-2023"
      },
      {
          "Car Make-Model": "Opel  Insignia  2016-2023"
      },
      {
          "Car Make-Model": "Opel  Karl  2016-2023"
      },
      {
          "Car Make-Model": "Opel  Mokka  2016-2023"
      },
      {
          "Car Make-Model": "Opel  Vivaro  2019-2023"
      },
      {
          "Car Make-Model": "Opel  Zafira  2016-2023"
      },
      {
          "Car Make-Model": "Opel  Zafira Life  2019-2023"
      },
      {
          "Car Make-Model": "Peugeot  108 2018-2023"
      },
      {
          "Car Make-Model": "Peugeot  208 2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  2008 2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  301 2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  308 2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  308 SW  2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  3008 2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  508 2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  508 SW  2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  5008 2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  Expert  2017-2023"
      },
      {
          "Car Make-Model": "Peugeot  Partner  2018-2023"
      },
      {
          "Car Make-Model": "Peugeot  Rifter  2018-2023"
      },
      {
          "Car Make-Model": "Peugeot  Traveller  2017-2023"
      },
      {
          "Car Make-Model": "Porsche  911 2022- 2022-2023"
      },
      {
          "Car Make-Model": "Porsche  Cayenne 2022- 2022-2023"
      },
      {
          "Car Make-Model": "Ram  1500 2018-2023"
      },
      {
          "Car Make-Model": "Ram  2500 2018-2023"
      },
      {
          "Car Make-Model": "Ram  3500 2018-2023"
      },
      {
          "Car Make-Model": "Ram  Chassis Cab  2018-2023"
      },
      {
          "Car Make-Model": "Renault  Captur  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Clio  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Clio Estate  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Espace  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Grand Scénic  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Kadjar  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Kangoo 2017-2023"
      },
      {
          "Car Make-Model": "Renault  Koleos 2017-2023"
      },
      {
          "Car Make-Model": "Renault  Master 2017-2023"
      },
      {
          "Car Make-Model": "Renault  Mégane  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Mégane Estate  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Scénic  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Talisman  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Talisman Estate 2017-2023"
      },
      {
          "Car Make-Model": "Renault  Trafic  2017-2023"
      },
      {
          "Car Make-Model": "Renault  Twingo 2017-2023"
      },
      {
          "Car Make-Model": "Renault  ZOE  2017-2023"
      },
      {
          "Car Make-Model": "SEAT  Alhambra  2016-2023"
      },
      {
          "Car Make-Model": "SEAT  Arona  2017-2023"
      },
      {
          "Car Make-Model": "SEAT  Ateca  2016-2023"
      },
      {
          "Car Make-Model": "SEAT  Ibiza  2016-2023"
      },
      {
          "Car Make-Model": "SEAT  León  2016-2023"
      },
      {
          "Car Make-Model": "SEAT  Toledo  2016-2023"
      },
      {
          "Car Make-Model": "Skoda  Fabia  2016-2023"
      },
      {
          "Car Make-Model": "Skoda  Fabia Combi  2016-2023"
      },
      {
          "Car Make-Model": "Skoda  Kamiq  2019-2023"
      },
      {
          "Car Make-Model": "Skoda  Karoq  2018-2023"
      },
      {
          "Car Make-Model": "Skoda  Kodiaq  2017-2023"
      },
      {
          "Car Make-Model": "Skoda  Octavia  2016-2023"
      },
      {
          "Car Make-Model": "Skoda  Octavia Combi  2016-2023"
      },
      {
          "Car Make-Model": "Skoda  Rapid  2016-2019"
      },
      {
          "Car Make-Model": "Skoda  Rapid Spaceback  2016-2019"
      },
      {
          "Car Make-Model": "Skoda  Scala  2019-2023"
      },
      {
          "Car Make-Model": "Skoda  Superb  2016-2023"
      },
      {
          "Car Make-Model": "Skoda  Superb Combi  2016-2023"
      },
      {
          "Car Make-Model": "Skoda  Yeti  2016-2023"
      },
      {
          "Car Make-Model": "Smart  fortwo  2017-2023"
      },
      {
          "Car Make-Model": "Smart  fortwo cabrio  2017-2023"
      },
      {
          "Car Make-Model": "Smart  forfour  2017-2023"
      },
      {
          "Car Make-Model": "SsangYong  Rexton  2017-2023"
      },
      {
          "Car Make-Model": "SsangYong  Musso Sports  2018-2023"
      },
      {
          "Car Make-Model": "Subaru  Ascent  2019-2023"
      },
      {
          "Car Make-Model": "Subaru  BRZ  2018-2023"
      },
      {
          "Car Make-Model": "Subaru  Forester  2019-2023"
      },
      {
          "Car Make-Model": "Subaru  Impreza  2017-2023"
      },
      {
          "Car Make-Model": "Subaru  Legacy/Liberty  2018-2023"
      },
      {
          "Car Make-Model": "Subaru  Outback  2018-2023"
      },
      {
          "Car Make-Model": "Subaru  WRX  2019-2023"
      },
      {
          "Car Make-Model": "Subaru  XV / Crosstrek 2018-2023"
      },
      {
          "Car Make-Model": "Suzuki  Hustler  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  Ignis  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  Lapin  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  Solio  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  Solio Bandit  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  Spacia  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  Spacia Custom  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  Spacia Custom Z  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  Swift  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  WagonR  2016-2023"
      },
      {
          "Car Make-Model": "Suzuki  WagonR Stingray  2016-2023"
      },
      {
          "Car Make-Model": "Tata Motors  Altroz  2020-2023"
      },
      {
          "Car Make-Model": "Tata Motors  Harrier  2019-2023"
      },
      {
          "Car Make-Model": "Tata Motors  Hexa  2019-2023"
      },
      {
          "Car Make-Model": "Tata Motors  Nexon  2017-2023"
      },
      {
          "Car Make-Model": "Tata Motors  Nexon  2019-2023"
      },
      {
          "Car Make-Model": "Tata Motors  Tiago  2019-2023"
      },
      {
          "Car Make-Model": "Tata Motors  Tigor  2018-2023"
      },
      {
          "Car Make-Model": "Toyota  4Runner  2020-2023"
      },
      {
          "Car Make-Model": "Toyota  Aygo  2018-2023"
      },
      {
          "Car Make-Model": "Toyota  Sequoia  2020-2023"
      },
      {
          "Car Make-Model": "Toyota  Tacoma  2020-2023"
      },
      {
          "Car Make-Model": "Toyota  Tundra 2 2020-2023"
      },
      {
          "Car Make-Model": "Toyota  Yaris (Europe Only)  2019-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Adam  2016-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Astra  2016-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Combo  2018-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Corsa  2016-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Crossland X  2017-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Grandland X  2018-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Insignia  2016-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Mokka 2016-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Viva  2016-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Vivaro  2019-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Zafira  2016-2023"
      },
      {
          "Car Make-Model": "Vauxhall  Zafira Life 2019-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Ameo  2017-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Arteon  2017-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Atlas  2018-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Beetle  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Beetle Cabriolet  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  CC  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  CrossFox  2017-2023"
      },
      {
          "Car Make-Model": "Volkswagen  e-Golf  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Fox  2017-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Gol  2017-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Golf  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Golf Cabriolet  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Golf GTD  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Golf GTE  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Golf GTI  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Golf Sportsvan  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Golf Variant 2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Jetta  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  NMS-Passat  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Passat  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Passat Alltrack  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Passat Variant 2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Passat GTE  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Polo  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Polo GTI  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Sagitar 2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Saveiro  2017-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Scirocco  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Sharan  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Suran  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  T-Cross  2019-2023"
      },
      {
          "Car Make-Model": "Volkswagen  T-Roc  2018-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Teramont  2018-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Tiguan  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Tiguan Allspace  2018-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Touareg  2018-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Touran  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Virtus  2018-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Voyage 2017-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Amarok  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Caddy  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  California  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Caravelle  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Crafter  2017-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Crafter Kastenwagen  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Crafter Pritsche  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Multivan  2016-2023"
      },
      {
          "Car Make-Model": "Volkswagen  Transporter  2016-2023"
      },
      {
          "Car Make-Model": "Volvo  XC90  2017-2023"
      },
      {
          "Car Make-Model": "Volvo  S90  2017-2023"
      },
      {
          "Car Make-Model": "Volvo  V90  2017-2023"
      },
      {
          "Car Make-Model": "Volvo  V60 Cross Country 2019-2023"
      },
      {
          "Car Make-Model": "Volvo  V90 Cross Country  2017-2023"
      },
      {
          "Car Make-Model": "Volvo  XC60  2018-2023"
      },
      {
          "Car Make-Model": "Volvo  S60  2019-2023"
      },
      {
          "Car Make-Model": "Volvo  V60  2019-2023"
      },
      {
          "Car Make-Model": "Volvo  XC40  2018-2023"
      }
    ],
    locomotive: [
        {
            "Car Make-Model": "A718PN"
        },
        {
            "Car Make-Model": "AVH-2300NEX"
        },
        {
            "Car Make-Model": "AVH-2330NEX"
        },
        {
            "Car Make-Model": "AVH-2400NEX"
        },
        {
            "Car Make-Model": "AVH-2440NEX"
        },
        {
            "Car Make-Model": "AVH-2500NEX"
        },
        {
            "Car Make-Model": "AVH-2550NEX"
        },
        {
            "Car Make-Model": "AVH-3300NEX"
        },
        {
            "Car Make-Model": "AVH-3400NEX"
        },
        {
            "Car Make-Model": "AVH-3500NEX"
        },
        {
            "Car Make-Model": "AVH-4100NEX"
        },
        {
            "Car Make-Model": "AVH-4200NEX"
        },
        {
            "Car Make-Model": "AVH-W4400NEX*"
        },
        {
            "Car Make-Model": "AVH-W4500NEX*"
        },
        {
            "Car Make-Model": "AVH-X8700BT"
        },
        {
            "Car Make-Model": "AVH-X8750BT"
        },
        {
            "Car Make-Model": "AVH-X8790BT"
        },
        {
            "Car Make-Model": "AVH-X8800BT"
        },
        {
            "Car Make-Model": "AVH-X8850BT"
        },
        {
            "Car Make-Model": "AVH-X8890BT"
        },
        {
            "Car Make-Model": "AVH-Z5000BT"
        },
        {
            "Car Make-Model": "AVH-Z5000DAB"
        },
        {
            "Car Make-Model": "AVH-Z5050BT"
        },
        {
            "Car Make-Model": "AVH-Z5050TV"
        },
        {
            "Car Make-Model": "AVH-Z5080TV"
        },
        {
            "Car Make-Model": "AVH-Z5090BT"
        },
        {
            "Car Make-Model": "AVH-Z5100BT"
        },
        {
            "Car Make-Model": "AVH-Z5100DAB"
        },
        {
            "Car Make-Model": "AVH-Z5150BT"
        },
        {
            "Car Make-Model": "AVH-Z5150TV"
        },
        {
            "Car Make-Model": "AVH-Z5180TV"
        },
        {
            "Car Make-Model": "AVH-Z5190BT"
        },
        {
            "Car Make-Model": "AVH-Z5200BT"
        },
        {
            "Car Make-Model": "AVH-Z5200DAB"
        },
        {
            "Car Make-Model": "AVH-Z5250BT"
        },
        {
            "Car Make-Model": "AVH-Z5250TV"
        },
        {
            "Car Make-Model": "AVH-Z5280TV"
        },
        {
            "Car Make-Model": "AVH-Z5290BT"
        },
        {
            "Car Make-Model": "AVH-Z7050BT"
        },
        {
            "Car Make-Model": "AVH-Z7050TV"
        },
        {
            "Car Make-Model": "AVH-Z7080TV"
        },
        {
            "Car Make-Model": "AVH-Z7100DAB"
        },
        {
            "Car Make-Model": "AVH-Z7150BT"
        },
        {
            "Car Make-Model": "AVH-Z7150TV"
        },
        {
            "Car Make-Model": "AVH-Z7180TV"
        },
        {
            "Car Make-Model": "AVH-Z7200DAB"
        },
        {
            "Car Make-Model": "AVH-Z7250BT"
        },
        {
            "Car Make-Model": "AVH-Z7250TV"
        },
        {
            "Car Make-Model": "AVH-Z7280TV"
        },
        {
            "Car Make-Model": "AVH-Z9100BT*"
        },
        {
            "Car Make-Model": "AVH-Z9100DAB*"
        },
        {
            "Car Make-Model": "AVH-Z9150BT*"
        },
        {
            "Car Make-Model": "AVH-Z9180TV*"
        },
        {
            "Car Make-Model": "AVH-Z9190BT*"
        },
        {
            "Car Make-Model": "AVH-Z9200BT*"
        },
        {
            "Car Make-Model": "AVH-Z9200DAB*"
        },
        {
            "Car Make-Model": "AVH-Z9250BT*"
        },
        {
            "Car Make-Model": "AVH-Z9280TV*"
        },
        {
            "Car Make-Model": "AVH-Z9290BT*"
        },
        {
            "Car Make-Model": "AVH-ZL5050BT"
        },
        {
            "Car Make-Model": "AVH-ZL5150BT"
        },
        {
            "Car Make-Model": "AVIC-7200NEX"
        },
        {
            "Car Make-Model": "AVIC-7201NEX"
        },
        {
            "Car Make-Model": "AVIC-8200NEX"
        },
        {
            "Car Make-Model": "AVIC-8201NEX"
        },
        {
            "Car Make-Model": "AVIC-EVO1-DT2"
        },
        {
            "Car Make-Model": "AVIC-EVO1-DX2"
        },
        {
            "Car Make-Model": "AVIC-EVO1-G72"
        },
        {
            "Car Make-Model": "AVIC-EVO1-OC2"
        },
        {
            "Car Make-Model": "AVIC-EVO1-PL2"
        },
        {
            "Car Make-Model": "AVIC-F80BT"
        },
        {
            "Car Make-Model": "AVIC-F80DAB"
        },
        {
            "Car Make-Model": "AVIC-F80TV"
        },
        {
            "Car Make-Model": "AVIC-F88DAB"
        },
        {
            "Car Make-Model": "AVIC-W8400NEX*"
        },
        {
            "Car Make-Model": "AVIC-W8500NEX*"
        },
        {
            "Car Make-Model": "AVIC-W8600NEX*"
        },
        {
            "Car Make-Model": "AVIC-Z810DAB*"
        },
        {
            "Car Make-Model": "AVIC-Z820DAB*"
        },
        {
            "Car Make-Model": "AVIC-Z830DAB*"
        },
        {
            "Car Make-Model": "AVIC-Z910DAB*"
        },
        {
            "Car Make-Model": "AVIC-Z920DAB*"
        },
        {
            "Car Make-Model": "AVIC-Z930DAB*"
        },
        {
            "Car Make-Model": "B902PN"
        },
        {
            "Car Make-Model": "CA9009-BR"
        },
        {
            "Car Make-Model": "CA9015-NR 2019+"
        },
        {
            "Car Make-Model": "CNE-6703-A"
        },
        {
            "Car Make-Model": "CNE-6877MC-A"
        },
        {
            "Car Make-Model": "CNE-6997M-A"
        },
        {
            "Car Make-Model": "DD680R"
        },
        {
            "Car Make-Model": "DDX6704S"
        },
        {
            "Car Make-Model": "DDX6705S"
        },
        {
            "Car Make-Model": "DDX6904S"
        },
        {
            "Car Make-Model": "DDX6905S"
        },
        {
            "Car Make-Model": "DDX8706S *"
        },
        {
            "Car Make-Model": "DDX8905S"
        },
        {
            "Car Make-Model": "DDX8906S *"
        },
        {
            "Car Make-Model": "DDX9016DABS"
        },
        {
            "Car Make-Model": "DDX9016S"
        },
        {
            "Car Make-Model": "DDX9016SM"
        },
        {
            "Car Make-Model": "DDX9017DABS"
        },
        {
            "Car Make-Model": "DDX9017S"
        },
        {
            "Car Make-Model": "DDX9017SM"
        },
        {
            "Car Make-Model": "DDX9018BTS"
        },
        {
            "Car Make-Model": "DDX9018DABS"
        },
        {
            "Car Make-Model": "DDX9018S"
        },
        {
            "Car Make-Model": "DDX9018SM"
        },
        {
            "Car Make-Model": "DDX916WS"
        },
        {
            "Car Make-Model": "DDX916WSL"
        },
        {
            "Car Make-Model": "DDX916WSM"
        },
        {
            "Car Make-Model": "DDX917WS"
        },
        {
            "Car Make-Model": "DDX917WSM"
        },
        {
            "Car Make-Model": "DDX918WS"
        },
        {
            "Car Make-Model": "DDX918WSM"
        },
        {
            "Car Make-Model": "DDX9703S"
        },
        {
            "Car Make-Model": "DDX9704S"
        },
        {
            "Car Make-Model": "DDX9705S"
        },
        {
            "Car Make-Model": "DDX9716BTS"
        },
        {
            "Car Make-Model": "DDX9716BTSR"
        },
        {
            "Car Make-Model": "DDX9717BTS"
        },
        {
            "Car Make-Model": "DDX9903S"
        },
        {
            "Car Make-Model": "DDX9904S"
        },
        {
            "Car Make-Model": "DDX9905S"
        },
        {
            "Car Make-Model": "DDX9906XR *"
        },
        {
            "Car Make-Model": "DMH-1500NEX"
        },
        {
            "Car Make-Model": "DMH-2600NEX"
        },
        {
            "Car Make-Model": "DMH-2660NEX"
        },
        {
            "Car Make-Model": "DMH-C2500NEX"
        },
        {
            "Car Make-Model": "DMH-C2550NEX"
        },
        {
            "Car Make-Model": "DMH-C5500NEX"
        },
        {
            "Car Make-Model": "DMH-W4600NEX*"
        },
        {
            "Car Make-Model": "DMH-W4660NEX*"
        },
        {
            "Car Make-Model": "DMH-WC6600NEX*"
        },
        {
            "Car Make-Model": "DMH-WT7600NEX*"
        },
        {
            "Car Make-Model": "DMH-WT8600NEX*"
        },
        {
            "Car Make-Model": "DMH-Z5150BT"
        },
        {
            "Car Make-Model": "DMH-Z5290BT"
        },
        {
            "Car Make-Model": "DMH-Z5350BT"
        },
        {
            "Car Make-Model": "DMH-Z5350TV"
        },
        {
            "Car Make-Model": "DMH-Z5380TV"
        },
        {
            "Car Make-Model": "DMH-Z6350BT*"
        },
        {
            "Car Make-Model": "DMH-Z6380TV*"
        },
        {
            "Car Make-Model": "DMH-ZF9350BT*"
        },
        {
            "Car Make-Model": "DMH-ZF9380TV*"
        },
        {
            "Car Make-Model": "DMH-ZS5280TV"
        },
        {
            "Car Make-Model": "DMH-ZS8250BT"
        },
        {
            "Car Make-Model": "DMH-ZS8280TV"
        },
        {
            "Car Make-Model": "DMH-ZS8290BT"
        },
        {
            "Car Make-Model": "DMH-ZS9350BT*"
        },
        {
            "Car Make-Model": "DMH-ZS9380TV*"
        },
        {
            "Car Make-Model": "DMX7017BTS"
        },
        {
            "Car Make-Model": "DMX7017DABS"
        },
        {
            "Car Make-Model": "DMX7018BTS"
        },
        {
            "Car Make-Model": "DMX7018DABS"
        },
        {
            "Car Make-Model": "DMX7704S"
        },
        {
            "Car Make-Model": "DMX7705S"
        },
        {
            "Car Make-Model": "DMX8018S"
        },
        {
            "Car Make-Model": "DMX905S"
        },
        {
            "Car Make-Model": "DMX906S *"
        },
        {
            "Car Make-Model": "DMX9706S *"
        },
        {
            "Car Make-Model": "DN56B6H"
        },
        {
            "Car Make-Model": "DN6V56A"
        },
        {
            "Car Make-Model": "DNX516DABS"
        },
        {
            "Car Make-Model": "DNX5180BTS"
        },
        {
            "Car Make-Model": "DNX5180DABS"
        },
        {
            "Car Make-Model": "DNX5180S"
        },
        {
            "Car Make-Model": "DNX5180SM"
        },
        {
            "Car Make-Model": "DNX518VDABS"
        },
        {
            "Car Make-Model": "DNX574S"
        },
        {
            "Car Make-Model": "DNX575S"
        },
        {
            "Car Make-Model": "DNX694S"
        },
        {
            "Car Make-Model": "DNX695S"
        },
        {
            "Car Make-Model": "DNX7160BTS"
        },
        {
            "Car Make-Model": "DNX716WDABS"
        },
        {
            "Car Make-Model": "DNX7170DABS"
        },
        {
            "Car Make-Model": "DNX773S"
        },
        {
            "Car Make-Model": "DNX775RVS"
        },
        {
            "Car Make-Model": "DNX8160DABS"
        },
        {
            "Car Make-Model": "DNX8160S"
        },
        {
            "Car Make-Model": "DNX8160SM"
        },
        {
            "Car Make-Model": "DNX8170DABS"
        },
        {
            "Car Make-Model": "DNX8180DABS"
        },
        {
            "Car Make-Model": "DNX874S"
        },
        {
            "Car Make-Model": "DNX875S"
        },
        {
            "Car Make-Model": "DNX893S"
        },
        {
            "Car Make-Model": "DNX9170DABS"
        },
        {
            "Car Make-Model": "DNX9170S"
        },
        {
            "Car Make-Model": "DNX9170SM"
        },
        {
            "Car Make-Model": "DNX9180DABS"
        },
        {
            "Car Make-Model": "DNX9180S"
        },
        {
            "Car Make-Model": "DNX9180SM"
        },
        {
            "Car Make-Model": "DNX994S"
        },
        {
            "Car Make-Model": "DNX995S"
        },
        {
            "Car Make-Model": "DNX996XR *"
        },
        {
            "Car Make-Model": "DPV-7000"
        },
        {
            "Car Make-Model": "DV-1"
        },
        {
            "Car Make-Model": "F2-AVX7MX"
        },
        {
            "Car Make-Model": "FH-8500DVS"
        },
        {
            "Car Make-Model": "FH-9300DVS"
        },
        {
            "Car Make-Model": "FH-9400DVS"
        },
        {
            "Car Make-Model": "GX-3800"
        },
        {
            "Car Make-Model": "GX-3810"
        },
        {
            "Car Make-Model": "GX-3820"
        },
        {
            "Car Make-Model": "GX-3900"
        },
        {
            "Car Make-Model": "GX-3910"
        },
        {
            "Car Make-Model": "GX-3920"
        },
        {
            "Car Make-Model": "GX-3950"
        },
        {
            "Car Make-Model": "GX-3980"
        },
        {
            "Car Make-Model": "HM4Z05A"
        },
        {
            "Car Make-Model": "i209"
        },
        {
            "Car Make-Model": "i902D"
        },
        {
            "Car Make-Model": "iLX-207"
        },
        {
            "Car Make-Model": "iLX-702D"
        },
        {
            "Car Make-Model": "INE-W710D"
        },
        {
            "Car Make-Model": "INE-W977A"
        },
        {
            "Car Make-Model": "INE-W977HD"
        },
        {
            "Car Make-Model": "KW-M730BT"
        },
        {
            "Car Make-Model": "KW-M740BT"
        },
        {
            "Car Make-Model": "KW-M740BTM"
        },
        {
            "Car Make-Model": "KW-M741BT"
        },
        {
            "Car Make-Model": "KW-M745DBT"
        },
        {
            "Car Make-Model": "KW-M845BW"
        },
        {
            "Car Make-Model": "KW-M855BW *"
        },
        {
            "Car Make-Model": "KW-V830BT"
        },
        {
            "Car Make-Model": "KW-V840BT"
        },
        {
            "Car Make-Model": "KW-V930BW"
        },
        {
            "Car Make-Model": "KW-V930BWM"
        },
        {
            "Car Make-Model": "KW-V940BTM"
        },
        {
            "Car Make-Model": "KW-V940BW"
        },
        {
            "Car Make-Model": "KW-V950BW *"
        },
        {
            "Car Make-Model": "Legend CP100"
        },
        {
            "Car Make-Model": "M-DL9000"
        },
        {
            "Car Make-Model": "M710PT"
        },
        {
            "Car Make-Model": "M717PS"
        },
        {
            "Car Make-Model": "M901PT"
        },
        {
            "Car Make-Model": "MDV-Z904"
        },
        {
            "Car Make-Model": "MDV-Z904W"
        },
        {
            "Car Make-Model": "MDV-Z905"
        },
        {
            "Car Make-Model": "MDV-Z905W"
        },
        {
            "Car Make-Model": "Monte Carlo 750"
        },
        {
            "Car Make-Model": "MVH-2300NEX"
        },
        {
            "Car Make-Model": "MVH-2400NEX"
        },
        {
            "Car Make-Model": "MVH-AV251BT"
        },
        {
            "Car Make-Model": "MVH-Z5050BT"
        },
        {
            "Car Make-Model": "New York 750"
        },
        {
            "Car Make-Model": "NXV977D"
        },
        {
            "Car Make-Model": "NXV987D"
        },
        {
            "Car Make-Model": "Osaka 760"
        },
        {
            "Car Make-Model": "RD706P (AE6H0R7F)"
        },
        {
            "Car Make-Model": "RM4Y65"
        },
        {
            "Car Make-Model": "RM4Z24A"
        },
        {
            "Car Make-Model": "RN6V56A"
        },
        {
            "Car Make-Model": "RQ9012-BR 2018+"
        },
        {
            "Car Make-Model": "San Pedro 950"
        },
        {
            "Car Make-Model": "SPH-DA230DAB"
        },
        {
            "Car Make-Model": "SPH-DA240BT"
        },
        {
            "Car Make-Model": "SPH-DA250DAB"
        },
        {
            "Car Make-Model": "SPH-EVO62DAB"
        },
        {
            "Car Make-Model": "SPH-EVO82DAB"
        },
        {
            "Car Make-Model": "SPH-EVO93DAB*"
        },
        {
            "Car Make-Model": "Strada CN-F1D"
        },
        {
            "Car Make-Model": "U621P"
        },
        {
            "Car Make-Model": "U701P"
        },
        {
            "Car Make-Model": "U702P"
        },
        {
            "Car Make-Model": "U703P"
        },
        {
            "Car Make-Model": "U703PT"
        },
        {
            "Car Make-Model": "U705PM"
        },
        {
            "Car Make-Model": "UN1880"
        },
        {
            "Car Make-Model": "UN1880E"
        },
        {
            "Car Make-Model": "X208AU"
        },
        {
            "Car Make-Model": "X208U"
        },
        {
            "Car Make-Model": "X209D"
        },
        {
            "Car Make-Model": "X802D-U"
        },
        {
            "Car Make-Model": "X902D"
        },
        {
            "Car Make-Model": "XAV-AX100"
        },
        {
            "Car Make-Model": "XAV-AX200"
        },
        {
            "Car Make-Model": "XAV-AX3000"
        },
        {
            "Car Make-Model": "XAV-AX3005D"
        },
        {
            "Car Make-Model": "XAV-AX5000"
        },
        {
            "Car Make-Model": "XAV-AX7000"
        },
        {
            "Car Make-Model": "XAV-AX8000"
        },
        {
            "Car Make-Model": "XAV-AX8050D"
        },
        {
            "Car Make-Model": "My system isn’t listed"
        }
    ]
  },
  apple: {
    car_model: [
      {
          "Car Make-Model": "Abarth  Abarth 595 2017 - 2022"
      },
      {
          "Car Make-Model": "Abarth  Abarth 695 2017 - 2022 "
      },
      {
          "Car Make-Model": "Acura  NSX 2017 - 2022 "
      },
      {
          "Car Make-Model": "Acura  MDX 2018 - 2022"
      },
      {
          "Car Make-Model": "Acura  TLX 2018 - 2022"
      },
      {
          "Car Make-Model": "Acura  ILX 2019 - 2022"
      },
      {
          "Car Make-Model": "Acura  RDX 2019 - 2022"
      },
      {
          "Car Make-Model": "Acura  Integra 2023"
      },
      {
          "Car Make-Model": "Alpha Romeo  Giulia 2018 - 2022"
      },
      {
          "Car Make-Model": "Alpha Romeo  Stelvio 2018 - 2022"
      },
      {
          "Car Make-Model": "Alpha Romeo  Tonale 2023"
      },
      {
          "Car Make-Model": "Aston Martin  DB9 Volante 2017"
      },
      {
          "Car Make-Model": "Aston Martin  V8 Vantage 2017"
      },
      {
          "Car Make-Model": "Aston Martin  V12 Vantage 2017"
      },
      {
          "Car Make-Model": "Aston Martin  Vanquish 2017 - 2018"
      },
      {
          "Car Make-Model": "Aston Martin  Rapide 2017 - 2018"
      },
      {
          "Car Make-Model": "Aston Martin  DBX 2021 - 2022"
      },
      {
          "Car Make-Model": "Audi  A3 2017 - 2022"
      },
      {
          "Car Make-Model": "Audi  A4 2017 - 2022 "
      },
      {
          "Car Make-Model": "Audi  A5 2017 - 2022 "
      },
      {
          "Car Make-Model": "Audi  A6 2017 - 2022 "
      },
      {
          "Car Make-Model": "Audi  A7 2017 - 2022"
      },
      {
          "Car Make-Model": "Audi  Q2 2017 - 2022"
      },
      {
          "Car Make-Model": "Audi  Q7 2017 - 2022"
      },
      {
          "Car Make-Model": "Audi  R8 2017 - 2022"
      },
      {
          "Car Make-Model": "Audi  TT 2017 - 2022"
      },
      {
          "Car Make-Model": "Audi  Q5 2018 - 2022"
      },
      {
          "Car Make-Model": "Audi  A8 2019 - 2022"
      },
      {
          "Car Make-Model": "Audi  e‑tron 2019 - 2022"
      },
      {
          "Car Make-Model": "Audi  Q8 2019 - 2022"
      },
      {
          "Car Make-Model": "Audi  Q3 2020 - 2022"
      },
      {
          "Car Make-Model": "Audi  e‑tron Sportback 2021 - 2022"
      },
      {
          "Car Make-Model": "Audi  e-tron GT 2022"
      },
      {
          "Car Make-Model": "Audi  Q4 e‑tron 2022"
      },
      {
          "Car Make-Model": "Audi  Q4 Sportback e‑tron 2022"
      },
      {
          "Car Make-Model": "Baojun  310 2018 - 2022"
      },
      {
          "Car Make-Model": "Baojun  310W 2018 - 2022"
      },
      {
          "Car Make-Model": "Baojun  510 2018 - 2022"
      },
      {
          "Car Make-Model": "Baojun  730 2020 - 2022"
      },
      {
          "Car Make-Model": "Bentley  Bentayga 2017 - 2022"
      },
      {
          "Car Make-Model": "Bentley  Continental 2019 - 2022"
      },
      {
          "Car Make-Model": "Bentley  Flying Spur 2020 - 2022"
      },
      {
          "Car Make-Model": "Borgward  BX3 2017 - 2022"
      },
      {
          "Car Make-Model": "Borgward  BX4 2017 - 2022"
      },
      {
          "Car Make-Model": "Borgward  BX5 2017 - 2022"
      },
      {
          "Car Make-Model": "Borgward  BX6 2017 - 2022"
      },
      {
          "Car Make-Model": "Buick  Excelle 2016 - 2017"
      },
      {
          "Car Make-Model": "Buick  LaCrosse 2016 - 2022"
      },
      {
          "Car Make-Model": "Buick  Regal 2016 - 2022"
      },
      {
          "Car Make-Model": "Buick  Encore 2017 - 2022"
      },
      {
          "Car Make-Model": "Buick  Envision 2017 - 2022"
      },
      {
          "Car Make-Model": "Buick  Enclave 2018 - 2022"
      },
      {
          "Car Make-Model": "Buick  GT 2018 - 2022"
      },
      {
          "Car Make-Model": "Buick  GT-MPV 2018 - 2022"
      },
      {
          "Car Make-Model": "Buick  GL6 2018 - 2022"
      },
      {
          "Car Make-Model": "Buick  VELITE 6 2020 - 2022"
      },
      {
          "Car Make-Model": "Buick  GL8 Avenir 2020 - 2022"
      },
      {
          "Car Make-Model": "Buick  GL8 ES 2020 - 2022"
      },
      {
          "Car Make-Model": "Buick  GL8 Business Travel Edition 2021 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  ELR 2016"
      },
      {
          "Car Make-Model": "Cadillac  ATS 2016 - 2019"
      },
      {
          "Car Make-Model": "Cadillac  ATS-V 2016 - 2019"
      },
      {
          "Car Make-Model": "Cadillac  CTS 2016 - 2019"
      },
      {
          "Car Make-Model": "Cadillac  CTS-V 2016 - 2019"
      },
      {
          "Car Make-Model": "Cadillac  CT6 2016 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  CT6-V 2016 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  XTS 2016 - 2019"
      },
      {
          "Car Make-Model": "Cadillac  XT5 2017 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  XT4 2019 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  CT4 2020 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  CT4-V 2020 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  CT5 2020 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  CT5-V 2020 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  XT6 2020 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  Escalade / ESV 2016 - 2022"
      },
      {
          "Car Make-Model": "Cadillac  CT4-V Blackwing 2022"
      },
      {
          "Car Make-Model": "Cadillac  CT5-V Blackwing 2022"
      },
      {
          "Car Make-Model": "Cadillac  LYRIQ 2023"
      },
      {
          "Car Make-Model": "Chery  Arrizo 5 2017 - 2022"
      },
      {
          "Car Make-Model": "Chery  Arrizo 7 2017 - 2022"
      },
      {
          "Car Make-Model": "Chery  Tiggo 3 2017 - 2022"
      },
      {
          "Car Make-Model": "Chery  Tiggo 3X 2017 - 2022"
      },
      {
          "Car Make-Model": "Chery  Tiggo 5X 2017 - 2022"
      },
      {
          "Car Make-Model": "Chery  Tiggo 2 2018 - 2022"
      },
      {
          "Car Make-Model": "Chery  Tiggo 4 2018 - 2022"
      },
      {
          "Car Make-Model": "Chery  Tiggo 8 2018 - 2022"
      },
      {
          "Car Make-Model": "Chery  Arrizo 6 2020 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Cavalier 2016 - 2017"
      },
      {
          "Car Make-Model": "Chevrolet  Volt 2016 - 2019"
      },
      {
          "Car Make-Model": "Chevrolet  Camaro 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Camaro Convertible 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Colorado 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Corvette 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Corvette Convertible 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Cruze 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Impala 2016 - 2020"
      },
      {
          "Car Make-Model": "Chevrolet  Malibu 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Sail LOVA 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Silverado 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Silverado HD 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Spark 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Suburban 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Tahoe 2016 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Aveo 2017 - 2020"
      },
      {
          "Car Make-Model": "Chevrolet  Bolt EV 2017 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Prisma 2017 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  S10 2017 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Sonic 2017 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Tracker 2017 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Trax 2017 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Equinox 2018 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Traverse 2018 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Blazer 2019 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Monza 2019 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Captiva 2020 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Trailblazer 2020 - 2022"
      },
      {
          "Car Make-Model": "Chevrolet  Bolt EUV 2022"
      },
      {
          "Car Make-Model": "Chrysler  300 2017 - 2022"
      },
      {
          "Car Make-Model": "Chrysler  Pacifica 2018 - 2022"
      },
      {
          "Car Make-Model": "Chrysler  Voyager 2020 - 2021"
      },
      {
          "Car Make-Model": "Citroen  Aircross 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  Berlingo Multispace 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C3 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C4 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C4 Picasso 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C5 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C5 Break 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C6 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  Jumper 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  Jumpy 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  Spacetourer 2016 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C3-AirCross 2017 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C3-XR 2017 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C4 Cactus 2017 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C4-L 2017 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C4-Lounge 2017 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C4 Spacetourer 2017 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C-Elysée 2017 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C-Quatre 2017 - 2022"
      },
      {
          "Car Make-Model": "Citroen  Berlingo 2018 - 2022"
      },
      {
          "Car Make-Model": "Citroen  C5 Aircross 2018 - 2022"
      },
      {
          "Car Make-Model": "Cowin Auto  E3 2017 - 2022"
      },
      {
          "Car Make-Model": "Datsun  GO 2019 - 2022"
      },
      {
          "Car Make-Model": "Datsun  GO+ 2019 - 2022"
      },
      {
          "Car Make-Model": "Dodge  Challenger 2017 - 2022"
      },
      {
          "Car Make-Model": "Dodge  Charger 2017 - 2022"
      },
      {
          "Car Make-Model": "Dodge  Durango 2018 - 2022"
      },
      {
          "Car Make-Model": "Dodge  Journey 2019 - 2021"
      },
      {
          "Car Make-Model": "Dodge  Hornet 2023"
      },
      {
          "Car Make-Model": "DS  DS 3 2016 - 2022"
      },
      {
          "Car Make-Model": "DS  DS 3 Cabrio 2016 - 2022"
      },
      {
          "Car Make-Model": "DS  DS 3 Crossback 2016 - 2022"
      },
      {
          "Car Make-Model": "DS  DS 4 2016 - 2022"
      },
      {
          "Car Make-Model": "DS  DS 5 2016 - 2022"
      },
      {
          "Car Make-Model": "DS  DS 4S 2017 - 2022"
      },
      {
          "Car Make-Model": "DS  DS 5LS 2017 - 2022"
      },
      {
          "Car Make-Model": "DS  DS 6 2017 - 2022"
      },
      {
          "Car Make-Model": "DS  DS 7 Crossback 2018 - 2022"
      },
      {
          "Car Make-Model": "Ferrari  FF 2016"
      },
      {
          "Car Make-Model": "Ferrari  F12 tdf 2016"
      },
      {
          "Car Make-Model": "Ferrari  California T 2016 - 2017"
      },
      {
          "Car Make-Model": "Ferrari  F12 Berlinetta 2016 - 2017"
      },
      {
          "Car Make-Model": "Ferrari  488 GTB 2016 - 2020"
      },
      {
          "Car Make-Model": "Ferrari  488 Spider 2016 - 2020"
      },
      {
          "Car Make-Model": "Ferrari  GTC4Lusso 2017 - 2020"
      },
      {
          "Car Make-Model": "Ferrari  812 Superfast 2018 - 2021"
      },
      {
          "Car Make-Model": "Ferrari  Portofino 2018 - 2022"
      },
      {
          "Car Make-Model": "Ferrari  Monza SP1 2019 - 2021"
      },
      {
          "Car Make-Model": "Ferrari  Monza SP2 2019 - 2021"
      },
      {
          "Car Make-Model": "Ferrari  F8 Spider 2020 - 2022"
      },
      {
          "Car Make-Model": "Ferrari  F8 Tributo 2020 - 2022"
      },
      {
          "Car Make-Model": "Ferrari  SF90 Stradale 2020 - 2022"
      },
      {
          "Car Make-Model": "Ferrari  812 GTS 2021 - 2022"
      },
      {
          "Car Make-Model": "Ferrari  Roma 2021 - 2022"
      },
      {
          "Car Make-Model": "Ferrari  SF90 Spider 2021 - 2022"
      },
      {
          "Car Make-Model": "Ferrari  296 GTB 2022"
      },
      {
          "Car Make-Model": "Fiat  500 2017 - 2022"
      },
      {
          "Car Make-Model": "Fiat  500L 2017 - 2022"
      },
      {
          "Car Make-Model": "Fiat  Tipo 2017 - 2022"
      },
      {
          "Car Make-Model": "Fiat  500X 2018 - 2022"
      },
      {
          "Car Make-Model": "Fiat  Argo 2018 - 2022"
      },
      {
          "Car Make-Model": "Ford  C-MAX 2017 - 2019"
      },
      {
          "Car Make-Model": "Ford  Fiesta 2017 - 2019"
      },
      {
          "Car Make-Model": "Ford  Flex 2017 - 2019"
      },
      {
          "Car Make-Model": "Ford  Focus 2017 - 2019"
      },
      {
          "Car Make-Model": "Ford  Taurus 2017 - 2019"
      },
      {
          "Car Make-Model": "Ford  Edge 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  Escape 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  Expedition 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  F-150 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  Fusion 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  Transit 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  Transit Connect 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  Mustang 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  Super Duty 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  Explorer 2017 - 2022"
      },
      {
          "Car Make-Model": "Ford  EcoSport 2018 - 2022"
      },
      {
          "Car Make-Model": "Ford  Ford GT 2018 - 2022"
      },
      {
          "Car Make-Model": "Ford  Mustang Mach-E 2021 - 2022"
      },
      {
          "Car Make-Model": "Ford  Bronco 2021 - 2022"
      },
      {
          "Car Make-Model": "Ford  Bronco Sport 2021 - 2022"
      },
      {
          "Car Make-Model": "Ford  Evos 2022"
      },
      {
          "Car Make-Model": "Ford  Maverick 2022"
      },
      {
          "Car Make-Model": "Genesis  G80 2017 - 2022"
      },
      {
          "Car Make-Model": "Genesis  G70 2020 - 2022"
      },
      {
          "Car Make-Model": "Genesis  G90 2020 - 2022"
      },
      {
          "Car Make-Model": "Genesis  GV80 2021 - 2022"
      },
      {
          "Car Make-Model": "Genesis  GV70 2022"
      },
      {
          "Car Make-Model": "Genesis  GV60 2022"
      },
      {
          "Car Make-Model": "Genesis  G90 2022"
      },
      {
          "Car Make-Model": "Genesis  GV60 2023"
      },
      {
          "Car Make-Model": "Genesis  G90 2023"
      },
      {
          "Car Make-Model": "GMC  Canyon 2016 - 2022"
      },
      {
          "Car Make-Model": "GMC  Sierra 2016 - 2022"
      },
      {
          "Car Make-Model": "GMC  Yukon 2016 - 2022"
      },
      {
          "Car Make-Model": "GMC  Yukon XL 2016 - 2022"
      },
      {
          "Car Make-Model": "GMC  Acadia 2017 - 2022"
      },
      {
          "Car Make-Model": "GMC  Terrain 2018 - 2022"
      },
      {
          "Car Make-Model": "GMC  GMC HUMMER EV Pickup 2022"
      },
      {
          "Car Make-Model": "GMC  GMC HUMMER EV SUV 2024"
      },
      {
          "Car Make-Model": "Holden  Captiva 2016 - 2020"
      },
      {
          "Car Make-Model": "Holden  Insignia 2016 - 2018"
      },
      {
          "Car Make-Model": "Holden  Spark 2016 - 2018"
      },
      {
          "Car Make-Model": "Holden  Colorado 2016 - 2020"
      },
      {
          "Car Make-Model": "Holden  Astra 2017 - 2020"
      },
      {
          "Car Make-Model": "Holden  Barina 2017 - 2020"
      },
      {
          "Car Make-Model": "Holden  Trailblazer 2017 - 2020"
      },
      {
          "Car Make-Model": "Holden  Commodore 2018 - 2020"
      },
      {
          "Car Make-Model": "Holden  Equinox 2018 - 2020"
      },
      {
          "Car Make-Model": "Holden  Trax 2018 - 2020"
      },
      {
          "Car Make-Model": "Holden  Acadia 2019 - 2020"
      },
      {
          "Car Make-Model": "Honda  Accord 2016 - 2022"
      },
      {
          "Car Make-Model": "Honda  Civic 2016 - 2022"
      },
      {
          "Car Make-Model": "Honda  Ridgeline 2017 - 2022"
      },
      {
          "Car Make-Model": "Honda  CR-V 2017 - 2022"
      },
      {
          "Car Make-Model": "Honda  Pilot 2017 - 2022"
      },
      {
          "Car Make-Model": "Honda  Odyssey 2018 - 2022"
      },
      {
          "Car Make-Model": "Honda  Clarity 2019 - 2022"
      },
      {
          "Car Make-Model": "Honda  Fit 2018 - 2020"
      },
      {
          "Car Make-Model": "Honda  HR-V 2019 - 2022"
      },
      {
          "Car Make-Model": "Honda  Insight 2019 - 2022"
      },
      {
          "Car Make-Model": "Honda  Passport 2019 - 2022"
      },
      {
          "Car Make-Model": "Honda  Gold Wing 2018 - 2022"
      },
      {
          "Car Make-Model": "Honda  Africa Twin 2020 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Genesis Sedan 2015 - 2016"
      },
      {
          "Car Make-Model": "Hyundai  Azera 2015 - 2018"
      },
      {
          "Car Make-Model": "Hyundai  Sonata 2015 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  i10 2016 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  i30 2016 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  i40 2016 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Elantra GT 2016 - 2020"
      },
      {
          "Car Make-Model": "Hyundai  Tucson 2016 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Veloster 2016 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Santa Fe 2017 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Ioniq 2017 - 2020"
      },
      {
          "Car Make-Model": "Hyundai  Kona 2017 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Santa Fe Sport 2017 - 2019"
      },
      {
          "Car Make-Model": "Hyundai  Elantra 2017 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Santa Fe XL 2019"
      },
      {
          "Car Make-Model": "Hyundai  Accent 2019 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Nexo 2020 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Palisade 2020 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Venue 2020 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Bayon 2021 - 2022"
      },
      {
          "Car Make-Model": "Hyundai  Casper 2022"
      },
      {
          "Car Make-Model": "Hyundai  Ioniq 5 2022"
      },
      {
          "Car Make-Model": "Hyundai  SANTA CRUZ 2022"
      },
      {
          "Car Make-Model": "Hyundai  IONIQ 6 2023"
      },
      {
          "Car Make-Model": "Hyundai  Palisade 2023"
      },
      {
          "Car Make-Model": "Indian-motorcycle  Challenger 2020 - 2022"
      },
      {
          "Car Make-Model": "Indian-motorcycle  Chieftain 2020 - 2022"
      },
      {
          "Car Make-Model": "Indian-motorcycle  Roadmaster 2020 - 2022"
      },
      {
          "Car Make-Model": "Infiniti  Q50 2020 - 2022"
      },
      {
          "Car Make-Model": "Infiniti  Q60 2020 - 2022"
      },
      {
          "Car Make-Model": "Infiniti  QX50 2020 - 2022"
      },
      {
          "Car Make-Model": "Infiniti  QX80 2020 - 2022"
      },
      {
          "Car Make-Model": "Infiniti  QX55 2022"
      },
      {
          "Car Make-Model": "Infiniti  QX60 2022"
      },
      {
          "Car Make-Model": "Jaguar  E-Pace 2019 - 2022"
      },
      {
          "Car Make-Model": "Jaguar  F-Pace 2019 - 2022"
      },
      {
          "Car Make-Model": "Jaguar  I-Pace 2019 - 2022"
      },
      {
          "Car Make-Model": "Jaguar  XE 2019 - 2020"
      },
      {
          "Car Make-Model": "Jaguar  XF 2019 - 2022"
      },
      {
          "Car Make-Model": "Jaguar  XJ 2019 - 2020"
      },
      {
          "Car Make-Model": "Jaguar  F-Type 2019 - 2022"
      },
      {
          "Car Make-Model": "Jeep  Compass 2017 - 2022"
      },
      {
          "Car Make-Model": "Jeep  Grand Cherokee 2018 - 2022"
      },
      {
          "Car Make-Model": "Jeep  Renegade 2018 - 2022"
      },
      {
          "Car Make-Model": "Jeep  Wrangler 2018 - 2022"
      },
      {
          "Car Make-Model": "Jeep  Cherokee 2020 - 2022"
      },
      {
          "Car Make-Model": "Jeep  Gladiator 2020 - 2022"
      },
      {
          "Car Make-Model": "Jeep  Grand Wagoneer 2022"
      },
      {
          "Car Make-Model": "Jeep  Wagoneer 2022"
      },
      {
          "Car Make-Model": "Kia  Soul 2014 - 2022"
      },
      {
          "Car Make-Model": "Kia  Optima 2015 - 2020"
      },
      {
          "Car Make-Model": "Kia  Optima Hybrid 2015 - 2020"
      },
      {
          "Car Make-Model": "Kia  Sedona 2015 - 2021"
      },
      {
          "Car Make-Model": "Kia  Soul EV 2015 - 2021"
      },
      {
          "Car Make-Model": "Kia  Cadenza 2017 - 2020"
      },
      {
          "Car Make-Model": "Kia  Sorento 2017 - 2022"
      },
      {
          "Car Make-Model": "Kia  Sportage 2017 - 2022"
      },
      {
          "Car Make-Model": "Kia  Forte 2017 - 2022"
      },
      {
          "Car Make-Model": "Kia  Niro 2017 - 2023"
      },
      {
          "Car Make-Model": "Kia  Optima Plug-In Hybrid 2017 - 2020"
      },
      {
          "Car Make-Model": "Kia  Niro Plug-In Hybrid 2018 - 2022"
      },
      {
          "Car Make-Model": "Kia  Rio 2018 - 2022"
      },
      {
          "Car Make-Model": "Kia  Stinger 2018 - 2022"
      },
      {
          "Car Make-Model": "Kia  K900 2019 - 2020"
      },
      {
          "Car Make-Model": "Kia  Telluride 2020 - 2022"
      },
      {
          "Car Make-Model": "Kia  Seltos 2021 - 2022"
      },
      {
          "Car Make-Model": "Kia  K5 2021 - 2022"
      },
      {
          "Car Make-Model": "Kia  K8 2021 - 2022"
      },
      {
          "Car Make-Model": "Kia  Carnival 2022"
      },
      {
          "Car Make-Model": "Kia  EV6 2022"
      },
      {
          "Car Make-Model": "Kia  Telluride 2023"
      },
      {
          "Car Make-Model": "Lada  Vesta 2021 - 2022"
      },
      {
          "Car Make-Model": "Lada  XRAY 2021 - 2022"
      },
      {
          "Car Make-Model": "Lada  Granta 2021 - 2022"
      },
      {
          "Car Make-Model": "Lada  Largus 2022"
      },
      {
          "Car Make-Model": "Lamborghini  Centenario 2017"
      },
      {
          "Car Make-Model": "Lamborghini  Aventador 2018 - 2022"
      },
      {
          "Car Make-Model": "Lamborghini  Huracán 2019 - 2022"
      },
      {
          "Car Make-Model": "Lamborghini  Urus 2019 - 2022"
      },
      {
          "Car Make-Model": "Land Rover  Discovery 2019 - 2022"
      },
      {
          "Car Make-Model": "Land Rover  Discovery Sport 2019 - 2022"
      },
      {
          "Car Make-Model": "Land Rover  Range Rover 2019 - 2022"
      },
      {
          "Car Make-Model": "Land Rover  Range Rover Evoque 2019 - 2022"
      },
      {
          "Car Make-Model": "Land Rover  Range Rover Sport 2019 - 2022"
      },
      {
          "Car Make-Model": "Land Rover  Range Rover Velar 2019 - 2022"
      },
      {
          "Car Make-Model": "Land Rover  Defender 2020 - 2022"
      },
      {
          "Car Make-Model": "Lexus  ES 2019 - 2022"
      },
      {
          "Car Make-Model": "Lexus  LC 2019 - 2022"
      },
      {
          "Car Make-Model": "Lexus  LS 2019 - 2022"
      },
      {
          "Car Make-Model": "Lexus  NX 2019 - 2022"
      },
      {
          "Car Make-Model": "Lexus  RC 2019 - 2022"
      },
      {
          "Car Make-Model": "Lexus  RC F 2019 - 2022"
      },
      {
          "Car Make-Model": "Lexus  UX 2019 - 2022"
      },
      {
          "Car Make-Model": "Lexus  RX 2020 - 2022"
      },
      {
          "Car Make-Model": "Lexus  ES Hybrid 2021 - 2022"
      },
      {
          "Car Make-Model": "Lexus  IS 2021 - 2022"
      },
      {
          "Car Make-Model": "Lexus  LC Convertible 2021 - 2022"
      },
      {
          "Car Make-Model": "Lexus  LC Hybrid 2021 - 2022"
      },
      {
          "Car Make-Model": "Lexus  LS Hybrid 2021 - 2022"
      },
      {
          "Car Make-Model": "Lexus  NX Hybrid 2021 - 2022"
      },
      {
          "Car Make-Model": "Lexus  RX Hybrid 2021 - 2022"
      },
      {
          "Car Make-Model": "Lexus  UX Hybrid 2021 - 2022"
      },
      {
          "Car Make-Model": "Lexus  GX 2022"
      },
      {
          "Car Make-Model": "Lexus  RZ 2023"
      },
      {
          "Car Make-Model": "LDV  G10 2015 - 2022"
      },
      {
          "Car Make-Model": "LDV  EV80 2017 - 2019"
      },
      {
          "Car Make-Model": "LDV  D90 2017 - 2022"
      },
      {
          "Car Make-Model": "LDV  T60 2017 - 2022"
      },
      {
          "Car Make-Model": "LDV  V80 2018 - 2022"
      },
      {
          "Car Make-Model": "LDV  DELIVER 9 2019 - 2022"
      },
      {
          "Car Make-Model": "LDV  eDELIVER 9 2020 - 2022"
      },
      {
          "Car Make-Model": "Lincoln   MKS 2017 - 2018"
      },
      {
          "Car Make-Model": "Lincoln   MKX 2017 - 2018"
      },
      {
          "Car Make-Model": "Lincoln   MKC 2017 - 2019"
      },
      {
          "Car Make-Model": "Lincoln   MKT 2017 - 2019"
      },
      {
          "Car Make-Model": "Lincoln   MKZ 2017 - 2020"
      },
      {
          "Car Make-Model": "Lincoln   Navigator 2017 - 2022"
      },
      {
          "Car Make-Model": "Lincoln   Continental 2017 - 2020"
      },
      {
          "Car Make-Model": "Lincoln   Nautilus 2018 - 2022"
      },
      {
          "Car Make-Model": "Lincoln   Aviator 2020 - 2022"
      },
      {
          "Car Make-Model": "Lincoln   Corsair 2020 - 2022"
      },
      {
          "Car Make-Model": "Mahindra  Alturas G4 2018 - 2022"
      },
      {
          "Car Make-Model": "Mahindra  Marazzo 2018 - 2022"
      },
      {
          "Car Make-Model": "Mahindra  Scorpio 2019 - 2022"
      },
      {
          "Car Make-Model": "Mahindra  XUV 300 2019 - 2022"
      },
      {
          "Car Make-Model": "Mahindra  XUV 500 2019 - 2022"
      },
      {
          "Car Make-Model": "Mahindra  Thar 2020 - 2022"
      },
      {
          "Car Make-Model": "Maserati  Ghibli 2017 - 2022"
      },
      {
          "Car Make-Model": "Maserati  Levante 2017 - 2022"
      },
      {
          "Car Make-Model": "Maserati  Quattroporte 2017 - 2022"
      },
      {
          "Car Make-Model": "Maserati  GT Convertible 2018 - 2021"
      },
      {
          "Car Make-Model": "Maserati  GranTurismo 2018 - 2020"
      },
      {
          "Car Make-Model": "Maxus  MC20 2022"
      },
      {
          "Car Make-Model": "Maxus  Grecale 2023"
      },
      {
          "Car Make-Model": "Maxus  G10 2015 - 2022"
      },
      {
          "Car Make-Model": "Maxus  EV80 2017 - 2019"
      },
      {
          "Car Make-Model": "Maxus  D90 2017 - 2022"
      },
      {
          "Car Make-Model": "Maxus  T60 2017 - 2022"
      },
      {
          "Car Make-Model": "Maxus  V80 2018 - 2022"
      },
      {
          "Car Make-Model": "Maxus  DELIVER 9 2019 - 2022"
      },
      {
          "Car Make-Model": "Maxus  eDELIVER 9 2020 - 2022"
      },
      {
          "Car Make-Model": "Mazda  Mazda6 2018 - 2022"
      },
      {
          "Car Make-Model": "Mazda  CX-5 2019 - 2022"
      },
      {
          "Car Make-Model": "Mazda  CX-8 2019 - 2022"
      },
      {
          "Car Make-Model": "Mazda  CX-9 2019 - 2022"
      },
      {
          "Car Make-Model": "Mazda  MX-5 2019 - 2022"
      },
      {
          "Car Make-Model": "Mazda  Mazda3 2019 - 2022"
      },
      {
          "Car Make-Model": "Mazda  CX-3 2020 - 2022"
      },
      {
          "Car Make-Model": "Mazda  CX30 2020 - 2022"
      },
      {
          "Car Make-Model": "Mazda  Mazda2 2020 - 2022"
      },
      {
          "Car Make-Model": "Mazda  MX-30 2021 - 2022"
      },
      {
          "Car Make-Model": "Mazda  X-50 2022"
      },
      {
          "Car Make-Model": "Mazda  CX-60 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz   A-Class 2016 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  B-Class 2016 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  CLA-Class 2016 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  CLS-Class 2016 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  E-Class Cabriolet 2016 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  E-Class Coupe 2016 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLA-Class 2016 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLE-Class 2016 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  X-Class 2017 - 2020"
      },
      {
          "Car Make-Model": "Mercedes-Benz  E-Class 2017 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLS-Class 2017 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  SL-Class 2017 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  Sprinter 2018"
      },
      {
          "Car Make-Model": "Mercedes-Benz  Vito 2018 - 2020"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLC-Class 2018 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  S-Class 2018 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  C-Class 2019 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  Metris 2020"
      },
      {
          "Car Make-Model": "Mercedes-Benz  V-Class 2020"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLB-Class 2020 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  GLS-Class 2020 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  Citan 2021"
      },
      {
          "Car Make-Model": "Mercedes-Benz  EQA-Class 2021 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  EQC-Class 2021 - 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  EQB-Class 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  EQS-Class 2022"
      },
      {
          "Car Make-Model": "Mercedes-Benz  EQE-Class 2023"
      },
      {
          "Car Make-Model": "MG  GT 2016"
      },
      {
          "Car Make-Model": "MG  MG5 2016 - 2022"
      },
      {
          "Car Make-Model": "MG  RX5 2017 - 2022"
      },
      {
          "Car Make-Model": "MG  GS 2017 - 2022"
      },
      {
          "Car Make-Model": "MG  ZP 2017 - 2022"
      },
      {
          "Car Make-Model": "MG  ZS 2017 - 2022"
      },
      {
          "Car Make-Model": "MG  Hector 2019 - 2022"
      },
      {
          "Car Make-Model": "MG  M GMG 2019 - 2022"
      },
      {
          "Car Make-Model": "MG  M GMG Ei5 2019 - 2022"
      },
      {
          "Car Make-Model": "MG  HS 2019 - 2022"
      },
      {
          "Car Make-Model": "MG  ZS EV 2019 - 2022"
      },
      {
          "Car Make-Model": "MG  eHS 2020 - 2022"
      },
      {
          "Car Make-Model": "MG  Gloster 2020 - 2022"
      },
      {
          "Car Make-Model": "MG  M GMG 3 2020 - 2022"
      },
      {
          "Car Make-Model": "Mini  Clubman 2018 - 2022"
      },
      {
          "Car Make-Model": "Mini  Countryman 2018 - 2022"
      },
      {
          "Car Make-Model": "Mini  Convertible 2019 - 2022"
      },
      {
          "Car Make-Model": "Mini  Hardtop 2 Door 2019 - 2022"
      },
      {
          "Car Make-Model": "Mini  Hardtop 4 Door 2019 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  i-MiEV 2017"
      },
      {
          "Car Make-Model": "Mitsubishi  Pajero 2016 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Pajero Sport 2016 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Mirage 2016 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Mirage G4 2016 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Outlander 2017 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Outlander PHEV 2017 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  ASX 2017 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Triton 2017 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Delica D:2 2017 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Delica D:2 Custom 2017 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Eclipse Cross 2018 - 2022"
      },
      {
          "Car Make-Model": "Mitsubishi  Xpander 2023"
      },
      {
          "Car Make-Model": "Nissan   Maxima 2017 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Micra 2017 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Murano 2017.5 - 2022"
      },
      {
          "Car Make-Model": "Nissan   GT-R 2018 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Kicks 2018 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Leaf 2018 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Rogue 2018 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Altima 2019 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Qashqai 2019 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Rogue Sport 2019 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Sentra 2019 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Terrano 2019 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Titan 2019 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Versa 2019 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Patrol 2020 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Armada 2021 - 2022"
      },
      {
          "Car Make-Model": "Nissan   XRAY 2021 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Granta 2021 - 2022"
      },
      {
          "Car Make-Model": "Nissan   Frontier 2022"
      },
      {
          "Car Make-Model": "Nissan   Pathfinder 2022"
      },
      {
          "Car Make-Model": "Nissan   Ariya 2022"
      },
      {
          "Car Make-Model": "Nissan   Largus 2016 - 2020"
      },
      {
          "Car Make-Model": "Opel  ADAM 2016 - 2020"
      },
      {
          "Car Make-Model": "Opel  Astra 2016 - 2020"
      },
      {
          "Car Make-Model": "Opel  Corsa 2016 - 2022"
      },
      {
          "Car Make-Model": "Opel  Insignia 2016 - 2022"
      },
      {
          "Car Make-Model": "Opel  KARL 2016 - 2020"
      },
      {
          "Car Make-Model": "Opel  Ampera-e 2017 - 2022"
      },
      {
          "Car Make-Model": "Opel  Crossland X 2017 - 2022"
      },
      {
          "Car Make-Model": "Opel  Mokka 2017 - 2022"
      },
      {
          "Car Make-Model": "Opel  Zafira 2017 - 2022"
      },
      {
          "Car Make-Model": "Opel  Combo Life 2018 - 2022"
      },
      {
          "Car Make-Model": "Opel  Grandland 2018 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  208 2016 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  2008 2016 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  308S 2016 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  3008 2016 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  4008 2016 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  408 2016 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  301 2017 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  308 2017 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  308 SW 2017 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  508 2017 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  5008 2017 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  Expert 2016 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  Partner Tepee 2016 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  Traveller 2016 - 2022"
      },
      {
          "Car Make-Model": "Peugeot  Rifter 2018 - 2022"
      },
      {
          "Car Make-Model": "Slingshot  Slingshot 2021 - 2022"
      },
      {
          "Car Make-Model": "Polestar  Polestar 1 2020 - 2022"
      },
      {
          "Car Make-Model": "Polestar  Polestar 2 2021 - 2022"
      },
      {
          "Car Make-Model": "Porsche  718 2017 - 2022"
      },
      {
          "Car Make-Model": "Porsche  Panamera 2017 - 2022"
      },
      {
          "Car Make-Model": "Porsche  Macan 2017 - 2022"
      },
      {
          "Car Make-Model": "Porsche  Cayenne 2017 - 2022"
      },
      {
          "Car Make-Model": "Porsche  911 2017 - 2022"
      },
      {
          "Car Make-Model": "Porsche  Taycan 2020 - 2022"
      },
      {
          "Car Make-Model": "RAM  Ram 1500 2018 - 2022"
      },
      {
          "Car Make-Model": "RAM  Ram 2500 2018 - 2022"
      },
      {
          "Car Make-Model": "RAM  Ram 3500 2018 - 2022"
      },
      {
          "Car Make-Model": "RAM  Ram 4500 2018 - 2022"
      },
      {
          "Car Make-Model": "Renault  Clio 2017 - 2022"
      },
      {
          "Car Make-Model": "Renault  Espace 2017 - 2022"
      },
      {
          "Car Make-Model": "Renault  Kadjar 2017 - 2022"
      },
      {
          "Car Make-Model": "Renault  Mégane 2017 - 2022"
      },
      {
          "Car Make-Model": "Renault  Mégane Estate 2017 - 2022"
      },
      {
          "Car Make-Model": "Renault  Scénic 2017 - 2022"
      },
      {
          "Car Make-Model": "Renault  Grand Scénic 2017 - 2022"
      },
      {
          "Car Make-Model": "Renault  Talisman 2017 - 2022"
      },
      {
          "Car Make-Model": "Renault  Talisman Estate 2017 - 2022"
      },
      {
          "Car Make-Model": "Renault  Koleos 2018 - 2022"
      },
      {
          "Car Make-Model": "Renault  Fluence 2018 - 2022"
      },
      {
          "Car Make-Model": "Renault  Twingo 2019 - 2020"
      },
      {
          "Car Make-Model": "Rolls-Royce  Cullinan 2020 - 2022"
      },
      {
          "Car Make-Model": "Rolls-Royce  Dawn 2020 - 2022"
      },
      {
          "Car Make-Model": "Rolls-Royce  Ghost 2020 - 2022"
      },
      {
          "Car Make-Model": "Rolls-Royce  Phantom 2020 - 2022"
      },
      {
          "Car Make-Model": "Rolls-Royce  Wraith 2020 - 2022"
      },
      {
          "Car Make-Model": "SEAT  Alhambra 2016 - 2022"
      },
      {
          "Car Make-Model": "SEAT  Ibiza 2016 - 2022"
      },
      {
          "Car Make-Model": "SEAT  Leon 2016 - 2022"
      },
      {
          "Car Make-Model": "SEAT  Toledo 2016 - 2022"
      },
      {
          "Car Make-Model": "SEAT  Ateca 2017 - 2022"
      },
      {
          "Car Make-Model": "SEAT  Arona 2018 - 2022"
      },
      {
          "Car Make-Model": "SEAT  Tarraco 2020 - 2022"
      },
      {
          "Car Make-Model": "Skoda  Yeti 2016 - 2017"
      },
      {
          "Car Make-Model": "Skoda  Fabia 2016 - 2022"
      },
      {
          "Car Make-Model": "Skoda  Octavia 2016 - 2022"
      },
      {
          "Car Make-Model": "Skoda  Rapid 2016 - 2022"
      },
      {
          "Car Make-Model": "Skoda  Superb 2016 - 2022"
      },
      {
          "Car Make-Model": "Skoda  Karoq 2017 - 2022"
      },
      {
          "Car Make-Model": "Skoda  Kodiaq 2017 - 2022"
      },
      {
          "Car Make-Model": "Skoda  Scala 2017 - 2022"
      },
      {
          "Car Make-Model": "Skoda  Kamiq 2018 - 2022"
      },
      {
          "Car Make-Model": "Skoda  Enyaq iV 2020 - 2022"
      },
      {
          "Car Make-Model": "Skoda  ENYAQ iV 2023"
      },
      {
          "Car Make-Model": "Subaru  Impreza 2017 - 2022"
      },
      {
          "Car Make-Model": "Subaru  BRZ 2018 - 2022"
      },
      {
          "Car Make-Model": "Subaru  Crosstrek 2018 - 2022"
      },
      {
          "Car Make-Model": "Subaru  Legacy 2018 - 2022"
      },
      {
          "Car Make-Model": "Subaru  Outback 2018 - 2022"
      },
      {
          "Car Make-Model": "Subaru  Ascent 2019 - 2022"
      },
      {
          "Car Make-Model": "Subaru  Forester 2019 - 2022"
      },
      {
          "Car Make-Model": "Subaru  WRX 2019 - 2022"
      },
      {
          "Car Make-Model": "Subaru  WRX STI 2019 - 2022"
      },
      {
          "Car Make-Model": "Subaru  Solterra 2023"
      },
      {
          "Car Make-Model": "Suzuki  Baleno 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Ciaz 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Hustler 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Ignis 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Lapin 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Solio 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Solio Bandit 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Spacia 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Spacia Custom 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  SX4 S-CROSS 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Vitara 2016 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Jimny 2018 - 2022"
      },
      {
          "Car Make-Model": "Suzuki  Swift 2018 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Aygo 2028 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Avalon 2019 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Corolla Hatchback 2019 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Camry 2019 - 2022"
      },
      {
          "Car Make-Model": "Toyota  C-HR 2019 - 2022"
      },
      {
          "Car Make-Model": "Toyota  RAV4 2019 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Sienna 2019 - 2022"
      },
      {
          "Car Make-Model": "Toyota  86 2020 - 2021"
      },
      {
          "Car Make-Model": "Toyota  4Runner 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Corolla 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Highlander 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Prius 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Prius Prime 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Sequoia 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  GR Supra 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Tacoma 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Tundra 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Yaris 2020 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Avanza 2021 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Mirai 2021- 2022"
      },
      {
          "Car Make-Model": "Toyota  Venza 2021 - 2022"
      },
      {
          "Car Make-Model": "Toyota  Corolla Cross 2022"
      },
      {
          "Car Make-Model": "Toyota  GR86 2022"
      },
      {
          "Car Make-Model": "Toyota  Foxy 2022"
      },
      {
          "Car Make-Model": "Toyota  bZ4X 2023"
      },
      {
          "Car Make-Model": "Vauxhall  ADAM 2016 - 2020"
      },
      {
          "Car Make-Model": "Vauxhall  Astra 2016 - 2020"
      },
      {
          "Car Make-Model": "Vauxhall  Corsa 2016 - 2020"
      },
      {
          "Car Make-Model": "Vauxhall  Insignia 2016 - 2020"
      },
      {
          "Car Make-Model": "Vauxhall  Viva 2016 - 2020"
      },
      {
          "Car Make-Model": "Vauxhall  Ampera-e 2017 - 2022"
      },
      {
          "Car Make-Model": "Vauxhall  Crossland-x 2017 - 2022"
      },
      {
          "Car Make-Model": "Vauxhall  Mokka 2017 - 2022"
      },
      {
          "Car Make-Model": "Vauxhall  Zafira 2017 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Spacefox 2016"
      },
      {
          "Car Make-Model": "Volkswagan  CC 2016 - 2018"
      },
      {
          "Car Make-Model": "Volkswagan  Scirocco 2016 - 2018"
      },
      {
          "Car Make-Model": "Volkswagan  Amarok 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Beetle 2016 - 2019"
      },
      {
          "Car Make-Model": "Volkswagan  Beetle Cabriolet 2016 - 2019"
      },
      {
          "Car Make-Model": "Volkswagan  Golf R 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Caddy 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  California 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Caravelle 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  e-Golf 2016 - 2021"
      },
      {
          "Car Make-Model": "Volkswagan  Fox 2016 - 2021"
      },
      {
          "Car Make-Model": "Volkswagan  Golf 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Golf Cabriolet 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Golf SportsVan 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Golf Variant 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Golf SportWagen 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  GTI 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Jetta 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Lamando 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Multivan 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Passat Variant 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Polo 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Sharan 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Tiguan 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Touran 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Transporter 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Passat 2016 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Atlas 2017 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Crafter 2017 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  CrossFox 2017 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Gol 2017 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Saveiro 2017 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Voyage 2017 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Arteon 2018 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Bora 2018 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Magotan 2018 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Sagitar 2018 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  T-Roc 2018 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  ID.3 2021 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  ID.4 2021 - 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Taos 2022"
      },
      {
          "Car Make-Model": "Volkswagan  ID.5 2022"
      },
      {
          "Car Make-Model": "Volkswagan  ID.6 2022"
      },
      {
          "Car Make-Model": "Volkswagan  Talagon 2022"
      },
      {
          "Car Make-Model": "Volkswagan  ID.Buzz 2023"
      },
      {
          "Car Make-Model": "Volvo  XC90 2016 - 2022"
      },
      {
          "Car Make-Model": "Volvo  S90 2017 - 2022"
      },
      {
          "Car Make-Model": "Volvo  V90 2017 - 2022"
      },
      {
          "Car Make-Model": "Volvo  XC60 2018 - 2022"
      },
      {
          "Car Make-Model": "Volvo  S60 2019 - 2022"
      },
      {
          "Car Make-Model": "Volvo  V60 2019 - 2022"
      },
      {
          "Car Make-Model": "Volvo  XC40 2019 - 2022"
      },
      {
          "Car Make-Model": "Volvo  C40 Recharge 2022"
      },
      {
          "Not Found": "Not Found"
      }
    ],
    locomotive: [
        {
            "Car Make-Model": "Alpine X208U"
        },
        {
            "Car Make-Model": "Alpine X308U"
        },
        {
            "Car Make-Model": "Blaupunkt Miami 620"
        },
        {
            "Car Make-Model": "Blaupunkt New York 750"
        },
        {
            "Car Make-Model": "Blaupunkt Oslo 590"
        },
        {
            "Car Make-Model": "Blaupunkt Rome 990 DAB BT"
        },
        {
            "Car Make-Model": "Blaupunkt Rome 990 DAB BT Erisin"
        },
        {
            "Car Make-Model": "Blaupunkt San Diego 530"
        },
        {
            "Car Make-Model": "Blaupunkt Stockholm 370 DAB BT"
        },
        {
            "Car Make-Model": "Blaupunkt Valencia 790 DAB BT"
        },
        {
            "Car Make-Model": "Clarion CZ305"
        },
        {
            "Car Make-Model": "Clarion CZ307E"
        },
        {
            "Car Make-Model": "Clarion CZ505E"
        },
        {
            "Car Make-Model": "Clarion CZ702"
        },
        {
            "Car Make-Model": "Clarion CZ702E"
        },
        {
            "Car Make-Model": "Clarion M508"
        },
        {
            "Car Make-Model": "Clarion NX604"
        },
        {
            "Car Make-Model": "Clarion NX604"
        },
        {
            "Car Make-Model": "Clarion NX702E"
        },
        {
            "Car Make-Model": "Clarion NX706E"
        },
        {
            "Car Make-Model": "Clarion NZ502E"
        },
        {
            "Car Make-Model": "Clarion NZ502E"
        },
        {
            "Car Make-Model": "Clarion VX807AU"
        },
        {
            "Car Make-Model": "Clarion VX807E"
        },
        {
            "Car Make-Model": "iLX-207"
        },
        {
            "Car Make-Model": "iLX-F259"
        },
        {
            "Car Make-Model": "iLX-F309"
        },
        {
            "Car Make-Model": "iLX-F309"
        },
        {
            "Car Make-Model": "iLX-W650BT"
        },
        {
            "Car Make-Model": "INE-W987HD"
        },
        {
            "Car Make-Model": "JVC KW-M750BT"
        },
        {
            "Car Make-Model": "JVC KW-M855BW"
        },
        {
            "Car Make-Model": "JVC KW-M865BW"
        },
        {
            "Car Make-Model": "JVC KW-V850BT"
        },
        {
            "Car Make-Model": "JVC KW-V940BW"
        },
        {
            "Car Make-Model": "JVC KW-V950BW"
        },
        {
            "Car Make-Model": "JVC KW-V960BW"
        },
        {
            "Car Make-Model": "JVC KW-Z1000W"
        },
        {
            "Car Make-Model": "JVC KW-Z2000W"
        },
        {
            "Car Make-Model": "JVC KW-Z3000W"
        },
        {
            "Car Make-Model": "JVC KW-Z4000W"
        },
        {
            "Car Make-Model": "Kenwood DDX6706S"
        },
        {
            "Car Make-Model": "Kenwood DDX8706S"
        },
        {
            "Car Make-Model": "Kenwood DDX8906S"
        },
        {
            "Car Make-Model": "Kenwood DDX9906XR"
        },
        {
            "Car Make-Model": "Kenwood DMX7706S"
        },
        {
            "Car Make-Model": "Kenwood DMX906S"
        },
        {
            "Car Make-Model": "Kenwood DMX957XR"
        },
        {
            "Car Make-Model": "Kenwood DNX696S"
        },
        {
            "Car Make-Model": "Kenwood DNX996XR"
        },
        {
            "Car Make-Model": "Pioneer AVH-1500NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-1550NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-2300NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-2330NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-2400NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-2500NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-2550NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-3300NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-3500NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-4200NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-4300NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-4400NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-4500NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-5000NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-501EX"
        },
        {
            "Car Make-Model": "Pioneer AVH-5100NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-5200NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-5300NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-601EX"
        },
        {
            "Car Make-Model": "Pioneer AVH-6100NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-6200NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-6300BT"
        },
        {
            "Car Make-Model": "Pioneer AVH-6300NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-701EX"
        },
        {
            "Car Make-Model": "Pioneer AVH-7100NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-7200NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-7300NEX"
        },
        {
            "Car Make-Model": "Pioneer AVH-7500NEX"
        },
        {
            "Car Make-Model": "Pioneer DMH-1500NEX"
        },
        {
            "Car Make-Model": "Pioneer DMH-220EX"
        },
        {
            "Car Make-Model": "Pioneer DMH-WC6600NEX"
        },
        {
            "Car Make-Model": "Pioneer DMH-WT8600NEX"
        },
        {
            "Car Make-Model": "Sony XAV-AX1000"
        },
        {
            "Car Make-Model": "Sony XAV-AX200"
        },
        {
            "Car Make-Model": "Sony XAV-AX210"
        },
        {
            "Car Make-Model": "Sony XAV-AX5000"
        },
        {
            "Car Make-Model": "Sony XAV-AX5500"
        },
        {
            "Car Make-Model": "Sony XAV-AX7000"
        },
        {
            "Car Make-Model": "Sony XAV-AX8000"
        },
        {
            "Car Make-Model": "My system isn’t listed"
        }
    ]
  }
}